import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import SelectRevisionScreen from "./SelectRevisionScreen";
import PreviewRevision from "./PreviewRevision";
import { getAuditTrailData } from "../../../../util/getAuditTrailData";
import { getRevAllNodesWithRevInfo, updateCurrentSnapshot } from "../../../../redux/procedureRevisionSlice";
import { getCurrentStatus } from "../../../../util/AppUtils.jsx";
import { getRevAndTraining, prepareCurrentSnapshot, uploadJsonToS3 } from "../../../../util/AppUtils";
import { copyVersionProcedureTreeNode } from "../../../../redux/sectionSlice";
import { showSnackbar } from "../../../../redux/snackbarSlice.js";
import { useNavigate } from "react-router-dom";

const VersionHistoryCopyReplace = ({
data_for_copy_and_replace,
onCancel
}) =>{

    const dispatch = useDispatch();;

    const navigate = useNavigate()
    
    const [selectedRev, setSelectedRev] = useState({}) 

    const [pageState, setPageState] = useState({pageType:"revselect"})

    const [savedRevAllNodes, setSavedRevAllNodes] = useState(null)

    const [newPreviewData, setNewPreviewData] = useState([])

    const {
      item_code_type:newSourceTypeName, 
      revision:newSourceRev, 
      partNumber:newSourcePartNumber, 
      from_item_code_type:old_from_item_code_type, 
      from_partNumber:old_from_partNumber, 
      from_revision:old_from_revision
    }  = data_for_copy_and_replace?.completeData?.version_content || {}

    const {part_number:newTargetPartNumber, rev:newTargetRev, type_name:newTargetTypeName} = selectedRev?.revision?.full || {}

    const action_to_show = `User copied and replaced ${newSourceTypeName} ${newSourcePartNumber}, Rev ${newSourceRev} into ${newTargetTypeName} ${newTargetPartNumber}, Rev ${newTargetRev}`;

    // Effect to fetch revision nodes when in preview mode
    useEffect(() => {
        if(pageState.pageType === "preview" && selectedRev?.revision?.full) {

            const { part_ref, procedure_revision_id } = selectedRev.revision.full;
            if(part_ref && procedure_revision_id) {
                dispatch(getRevAllNodesWithRevInfo({
                    partId: part_ref,
                    revisionId: procedure_revision_id
                })).then((result) => {
                    if (result.payload) {
                        setSavedRevAllNodes(result.payload);
                    }
                });
            }

            // Also set newData based on completeData logic
            if(data_for_copy_and_replace?.auditVc?.main_entry){
                const dtaclone = JSON.parse(JSON.stringify(data_for_copy_and_replace?.completeData));
                delete dtaclone.first_entry
                delete dtaclone.version_content
                const dt = Object.values(dtaclone)
                console.log("dt",dt)
                if(dt.length > 1){
                    setNewPreviewData(dt[dt.length-1]?.newContent || [])
                }else if(dt.length === 1){
                    setNewPreviewData(dt[0]?.newContent || [])
                }
            }else{
              setNewPreviewData([])
            }
        }
    }, [pageState.pageType, selectedRev?.revision?.full, dispatch]);

    // Helper functions to prepare data for PreviewRevision
    const prepareSourceDocument = () => {
      if (!data_for_copy_and_replace?.completeData?.version_content) return null;
      
      const sourceData = data_for_copy_and_replace.completeData.version_content;
      return {
        partId: sourceData.part_ref,
        revisionId: sourceData.procedure_rev_ref,
        partNumber: sourceData.partNumber,
        revision: sourceData.revision,
        type: sourceData.item_code_type,
        description: sourceData.partDescription || '',
        status: sourceData.status
      };
    };
    
    const prepareTargetDocument = () => {
      if (!selectedRev?.revision?.full) return null;
      
      const targetData = selectedRev.revision.full;
      const groupData = selectedRev.group;
      
      return {
        partId: targetData.part_ref,
        revisionId: targetData.procedure_revision_id,
        partNumber: groupData.partNumber,
        revision: targetData.rev,
        type: groupData.type,
        description: groupData.description || '',
        status: groupData.status,
        tree_node_id: targetData.tree_node_details?.tree_node_id
      };
    };
    
    const handlePreviewConfirm = async(comment) => {
      console.log(data_for_copy_and_replace?.completeData)
      console.log("selectedRev?.revision", selectedRev?.revision)
      
      const audit_trail_data = await getAuditTrailData({
        action: "REVISION_COPIED",
        comment,
        version_content: {
          action_to_show,
          main_entry: true
        }
      })
    
      const node_indexing = {}
      const procedure_node_data = []
    
        // Recursive function to search for matching tree_node_id in nested structures
      const findNodeRecursively = (node, targetNodeId) => {
        if (!node) return null;
        
        // Check if current node matches
        if (node.tree_node_id === targetNodeId) {
          return node;
        }
        
        // Search in steps array
        if (node.steps && Array.isArray(node.steps)) {
          for (const step of node.steps) {
            const found = findNodeRecursively(step, targetNodeId);
            if (found) return found;
          }
        }
        
        // Search in children array
        if (node.children && Array.isArray(node.children)) {
          for (const child of node.children) {
            const found = findNodeRecursively(child, targetNodeId);
            if (found) return found;
          }
        }
        
        // Search in substeps array
        if (node.substeps && Array.isArray(node.substeps)) {
          for (const substep of node.substeps) {
            const found = findNodeRecursively(substep, targetNodeId);
            if (found) return found;
          }
        }
        
        return null;
      };
    
      Object.entries(data_for_copy_and_replace?.completeData)?.forEach(([key, value])=>{
        let new_title = "";
        if(value.title){
          let modified_title = value.title;
          
          // Simple approach: remove everything before ". System Performs Operation" and add action_to_show
          const systemOperationIndex = modified_title.indexOf('. System Performs Operation');
          if (systemOperationIndex !== -1) {
            let afterSystemOperation = modified_title.substring(systemOperationIndex);
    
            if(value.first_entry){
                console.log("First entry")
                afterSystemOperation = afterSystemOperation.replace(
                  `${old_from_item_code_type} ${old_from_partNumber} Rev ${old_from_revision}`, 
                  `${newSourceTypeName} ${newSourcePartNumber} Rev ${newSourceRev}`
                )
            }
            else{
              afterSystemOperation = afterSystemOperation.replace(
                `${newSourcePartNumber}, Rev ${newSourceRev}`, 
                `${newTargetPartNumber}, Rev ${newTargetRev}`
              )
            }
    
            modified_title = `${action_to_show}${afterSystemOperation}`;
          }
    
          new_title = modified_title
        }
    
        if(!value.first_entry){
          if(value.newContent && Array.isArray(value.newContent)){
            value.newContent.forEach(node => {
              // Use recursive search to find the node in all nested structures
              const foundNode = findNodeRecursively(node, key);
              if(foundNode){
                procedure_node_data.push(foundNode);
              }
            });
          }
        }
    
        node_indexing[key] = {
          ...value,
          title: new_title
        }
      })

       

      delete node_indexing.version_content

      const { part_ref, procedure_revision_id, part_number, type_name, part_description,rev, } = selectedRev.revision.full;
      const revStaus = getCurrentStatus(selectedRev?.revision?.full);
      const revAndTrainingData = await getRevAndTraining(dispatch, part_ref)
      
      const snapshot_url = await uploadJsonToS3({
        ...node_indexing,
        version_content:{
          action_to_show: audit_trail_data.version_content.action_to_show,
          item_code_type: type_name,
          partNumber: part_number,
          status: revStaus,
          revision: rev,
          partDescription:part_description,
          operation: "bulk_audit_trail",
          ...revAndTrainingData,
          part_ref:part_ref,
          procedure_rev_ref:procedure_revision_id,
          from_item_code_type:newSourceTypeName, 
          from_partNumber:newSourcePartNumber, 
          from_revision:newSourceRev, 
        }
      },part_number,rev+"_COPEID_REPLACE",true)

      audit_trail_data.previous_content_snapshot = snapshot_url
      audit_trail_data.new_content_snapshot = snapshot_url

      
      Object.entries(node_indexing).forEach(([key, value]) => {
        node_indexing[key] = {
          title:node_indexing[key].title,
          previous_content_snapshot:snapshot_url,
          new_content_snapshot:snapshot_url
        }
      })

      if(node_indexing.first_entry){
        node_indexing.first_entry.first_entry = true; 
      }

      const payload = {
        to_procedure_tree_node_ref:selectedRev?.revision?.full?.tree_node_details?.tree_node_id,
        to_order: "",
        to_type: "",
        to_part_id_ref: part_ref,
        to_procedure_rev_ref: procedure_revision_id,
        to_section_id_ref: "",
        to_step_id_ref: "",
        to_substep_id_ref: "",
        to_child_node_ref: "",
        audit_trail_data,
        node_indexing,
        procedure_node_data,
        current_snapshot:null,
        current_updated_snapshot:null,
        is_copy_replace:true
      }

      await dispatch(updateCurrentSnapshot({
        partId: part_ref,
        revisionId: procedure_revision_id,
        partNumber: part_number,
        rev: rev,
        currentStatus: revStaus,
        type: type_name,
        revAndTrainingData
      }))
            
    
      dispatch(copyVersionProcedureTreeNode(payload)).then(resp=>{
        if(resp?.payload?.success){
            dispatch(showSnackbar({ message: 'Copy & Replace operation completed successfully!', type: 'success' }));
            navigate(
            `/revision-submission/${part_ref}/${rev}/${type_name}/${part_number}/${procedure_revision_id}/redirect`,
            { state: { status: 'Not Submitted' } }
          );
            window.scrollTo(0, 0);
        }else{
          dispatch(showSnackbar({ message: resp?.payload?.message, type: 'error' }));
        }
      })
      
    };
    
    console.log("selectedRev",selectedRev)
    console.log("data_for_copy_and_replace",data_for_copy_and_replace)
    console.log("savedRevAllNodes", savedRevAllNodes)
  
    return <>
      {
        pageState.pageType ==="revselect" && <SelectRevisionScreen 
          handleCancel={onCancel} 
          data_for_copy_and_replace={data_for_copy_and_replace}
          onSelect={(data)=>{
            setPageState({ showMain:false,pageType:"preview" });
            setSelectedRev(data);
          }}
        />
      }

      {
        pageState.pageType === "preview" && selectedRev && data_for_copy_and_replace && (
          <PreviewRevision
            sourceDocument={prepareSourceDocument()}
            targetDocument={prepareTargetDocument()}
            originalData={savedRevAllNodes?.data || []} 
            newData={newPreviewData}       
            onConfirm={handlePreviewConfirm}
            onCancel={onCancel}
            isLoading={false}
          />
        )
      }
    </>
}


export default VersionHistoryCopyReplace